module.exports = __webpack_public_path__ + "static/media/logo.07f813ad.svg";